import { Modal } from "./modal.class";
import { $elementChild } from "@grindex-common/helpers/elements";

function init($views) {
	$views.forEach(($view) => {
		const modal = new Modal($view);
		const $overlay = $elementChild($view, "modal-overlay");
		const $closeButton = $elementChild($view, "modal-close");
		if ($view.hasAttribute("data-primary-color") && $view.hasAttribute("data-secondary-color")) {
			$overlay.addEventListener("click", () => {
				modal.close();
				document.body.style.overflow = "initial";
			});
			$closeButton.addEventListener("click", () => {
				modal.close();
				document.body.style.overflow = "initial";
			});
		} else {
			$overlay.addEventListener("click", () => modal.close());
			$closeButton.addEventListener("click", () => modal.close());
		}
	});
}

export default {
	view: "modal",
	init,
};
